import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../App';
import '../styles/Header.css';

const Header = () => {
  const { darkMode, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img
            src={darkMode ? "/images/cardslah-logo-dark-mode.png" : "/images/cardslah-logo.png"}
            alt="CardsLah"
            className="logo-image"
          />
        </Link>

        <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${isActive('/') && location.pathname === '/' ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="link-text">HOME</span>
                <span className="link-burst">!</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/cards"
                className={`nav-link ${isActive('/cards') ? 'active' : ''}`}
                onClick={closeMenu}
              >
                <span className="link-text">CARDS</span>
                <span className="link-burst">!</span>
              </Link>
            </li>
            <li className="nav-item">
              <a href="/#news" className="nav-link" onClick={closeMenu}>
                <span className="link-text">NEWS</span>
                <span className="link-burst">!</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="/#events" className="nav-link" onClick={closeMenu}>
                <span className="link-text">EVENTS</span>
                <span className="link-burst">!</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="/#about" className="nav-link" onClick={closeMenu}>
                <span className="link-text">ABOUT</span>
                <span className="link-burst">!</span>
              </a>
            </li>
            <li className="nav-item">
              <a href="/#contact" className="nav-link" onClick={closeMenu}>
                <span className="link-text">CONTACT</span>
                <span className="link-burst">!</span>
              </a>
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            <div className="toggle-icon">
              {darkMode ? (
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
                </svg>
              )}
            </div>
            <span className="toggle-burst">POW!</span>
          </button>

          <button
            className={`menu-toggle ${menuOpen ? 'menu-open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
          </button>
        </div>
      </div>

      <div className="header-speed-lines"></div>
    </header>
  );
};

export default Header;
